/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "to": {
        "nu": ["latn"],
        "year": {
          "0": "taʻú ni",
          "1": "taʻu kahaʻu",
          "future": {
            "other": "ʻi he taʻu ʻe {0}"
          },
          "past": {
            "other": "taʻu ʻe {0} kuoʻosi"
          },
          "-1": "taʻu kuoʻosi"
        },
        "year-short": {
          "0": "taʻú ni",
          "1": "taʻu kahaʻu",
          "future": {
            "other": "ʻi he taʻu ʻe {0}"
          },
          "past": {
            "other": "taʻu ʻe {0} kuoʻosi"
          },
          "-1": "taʻu kuoʻosi"
        },
        "year-narrow": {
          "0": "taʻú ni",
          "1": "taʻu kahaʻu",
          "future": {
            "other": "ʻi he taʻu ʻe {0}"
          },
          "past": {
            "other": "taʻu ʻe {0} kuoʻosi"
          },
          "-1": "taʻu kuoʻosi"
        },
        "quarter": {
          "0": "kuata koʻeni",
          "1": "kuata hoko",
          "future": {
            "other": "ʻi he kuata ʻe {0}"
          },
          "past": {
            "other": "kuata ʻe {0} kuoʻosi"
          },
          "-1": "kuata kuoʻosi"
        },
        "quarter-short": {
          "0": "kuata koʻeni",
          "1": "kuata hoko",
          "future": {
            "other": "ʻi he kuata ʻe {0}"
          },
          "past": {
            "other": "kuata ʻe {0} kuoʻosi"
          },
          "-1": "kuata kuoʻosi"
        },
        "quarter-narrow": {
          "0": "kuata koʻeni",
          "1": "kuata hoko",
          "future": {
            "other": "ʻi he kuata ʻe {0}"
          },
          "past": {
            "other": "kuata ʻe {0} kuoʻosi"
          },
          "-1": "kuata kuoʻosi"
        },
        "month": {
          "0": "māhiná ni",
          "1": "māhina kahaʻu",
          "future": {
            "other": "ʻi he māhina ʻe {0}"
          },
          "past": {
            "other": "māhina ʻe {0} kuoʻosi"
          },
          "-1": "māhina kuoʻosi"
        },
        "month-short": {
          "0": "māhiná ni",
          "1": "māhina kahaʻu",
          "future": {
            "other": "ʻi he māhina ʻe {0}"
          },
          "past": {
            "other": "māhina ʻe {0} kuoʻosi"
          },
          "-1": "māhina kuoʻosi"
        },
        "month-narrow": {
          "0": "māhiná ni",
          "1": "māhina kahaʻu",
          "future": {
            "other": "ʻi he māhina ʻe {0}"
          },
          "past": {
            "other": "māhina ʻe {0} kuoʻosi"
          },
          "-1": "māhina kuoʻosi"
        },
        "week": {
          "0": "uiké ni",
          "1": "uike kahaʻu",
          "future": {
            "other": "ʻi he uike ʻe {0}"
          },
          "past": {
            "other": "uike ʻe {0} kuoʻosi"
          },
          "-1": "uike kuoʻosi"
        },
        "week-short": {
          "0": "uiké ni",
          "1": "uike kahaʻu",
          "future": {
            "other": "ʻi he uike ʻe {0}"
          },
          "past": {
            "other": "uike ʻe {0} kuoʻosi"
          },
          "-1": "uike kuoʻosi"
        },
        "week-narrow": {
          "0": "uiké ni",
          "1": "uike kahaʻu",
          "future": {
            "other": "ʻi he uike ʻe {0}"
          },
          "past": {
            "other": "uike ʻe {0} kuoʻosi"
          },
          "-1": "uike kuoʻosi"
        },
        "day": {
          "0": "ʻahó ni",
          "1": "ʻapongipongi",
          "2": "ʻahepongipongi",
          "future": {
            "other": "ʻi he ʻaho ʻe {0}"
          },
          "past": {
            "other": "ʻaho ʻe {0} kuoʻosi"
          },
          "-2": "ʻaneheafi",
          "-1": "ʻaneafi"
        },
        "day-short": {
          "0": "ʻahó ni",
          "1": "ʻapongipongi",
          "2": "ʻahepongipongi",
          "future": {
            "other": "ʻi he ʻaho ʻe {0}"
          },
          "past": {
            "other": "ʻaho ʻe {0} kuoʻosi"
          },
          "-2": "ʻaneheafi",
          "-1": "ʻaneafi"
        },
        "day-narrow": {
          "0": "ʻahó ni",
          "1": "ʻapongipongi",
          "2": "ʻahepongipongi",
          "future": {
            "other": "ʻi he ʻaho ʻe {0}"
          },
          "past": {
            "other": "ʻaho ʻe {0} kuoʻosi"
          },
          "-2": "ʻaneheafi",
          "-1": "ʻaneafi"
        },
        "hour": {
          "0": "ko e houa ʻeni",
          "future": {
            "other": "ʻi he houa ʻe {0}"
          },
          "past": {
            "other": "houa ʻe {0} kuoʻosi"
          }
        },
        "hour-short": {
          "0": "ko e houa ʻeni",
          "future": {
            "other": "ʻi he houa ʻe {0}"
          },
          "past": {
            "other": "houa ʻe {0} kuoʻosi"
          }
        },
        "hour-narrow": {
          "0": "ko e houa ʻeni",
          "future": {
            "other": "ʻi he houa ʻe {0}"
          },
          "past": {
            "other": "houa ʻe {0} kuoʻosi"
          }
        },
        "minute": {
          "0": "ko e miniti ʻeni",
          "future": {
            "other": "ʻi he miniti ʻe {0}"
          },
          "past": {
            "other": "miniti ʻe {0} kuoʻosi"
          }
        },
        "minute-short": {
          "0": "ko e miniti ʻeni",
          "future": {
            "other": "ʻi he miniti ʻe {0}"
          },
          "past": {
            "other": "miniti ʻe {0} kuoʻosi"
          }
        },
        "minute-narrow": {
          "0": "ko e miniti ʻeni",
          "future": {
            "other": "ʻi he miniti ʻe {0}"
          },
          "past": {
            "other": "miniti ʻe {0} kuoʻosi"
          }
        },
        "second": {
          "0": "taimí ni",
          "future": {
            "other": "ʻi he sekoni ʻe {0}"
          },
          "past": {
            "other": "sekoni ʻe {0} kuoʻosi"
          }
        },
        "second-short": {
          "0": "taimí ni",
          "future": {
            "other": "ʻi he sekoni ʻe {0}"
          },
          "past": {
            "other": "sekoni ʻe {0} kuoʻosi"
          }
        },
        "second-narrow": {
          "0": "taimí ni",
          "future": {
            "other": "ʻi he sekoni ʻe {0}"
          },
          "past": {
            "other": "sekoni ʻe {0} kuoʻosi"
          }
        }
      }
    },
    "availableLocales": ["to"],
    "aliases": {},
    "parentLocales": {}
  });
}